import React from 'react'
import Button from './Button'
import BarrierWhiteSvg from '../../../assets/icons/BarrierWhiteSvg'
import GuestWhiteSvg from '../../../assets/icons/GuestWhiteSvg'
import HistoryArrowsWhiteSvg from '../../../assets/icons/HistoryArrowsWhiteSvg'

// 2x2 grid — Giriş/Çıkış Bariyer üst sıra, Misafir/Geçmiş alt sıra.
const ProcessButtons = ({
  entryBarrierOnClick,
  exitBarrierOnClick,
  guestOnClick,
  historyOnClick,
  barrierActionDirection = null, // 'entry' | 'exit' | null — hangi buton işlemde
  isBarrierActionInProgress = false,
}) => {
  const entryBusy = isBarrierActionInProgress && barrierActionDirection === 'entry'
  const exitBusy = isBarrierActionInProgress && barrierActionDirection === 'exit'

  return (
    <div className='bahceButtonsDiv'>
      <Button
        text={entryBusy ? 'Kontrol ediliyor...' : 'Giriş Bariyerini Aç'}
        background={'linear-gradient(0.65turn, #77DBEB, #1681B1)'}
        svg={<BarrierWhiteSvg />}
        onClick={entryBarrierOnClick}
        disabled={isBarrierActionInProgress}
        loading={entryBusy}
      />
      <Button
        text={exitBusy ? 'Kontrol ediliyor...' : 'Çıkış Bariyerini Aç'}
        background={'linear-gradient(0.65turn, #F5A55C, #C76A1E)'}
        svg={<BarrierWhiteSvg />}
        onClick={exitBarrierOnClick}
        disabled={isBarrierActionInProgress}
        loading={exitBusy}
      />
      <Button
        text='Misafir İşlemleri'
        background={'linear-gradient(0.65turn, #FC74A4, #A5204E)'}
        svg={<GuestWhiteSvg />}
        onClick={guestOnClick}
      />
      <Button
        text='Ziyaret Geçmişi'
        background={'linear-gradient(0.65turn, #86C2A8, #205C42)'}
        svg={<HistoryArrowsWhiteSvg />}
        onClick={historyOnClick}
      />
    </div>
  )
}

export default ProcessButtons
